module.exports = __webpack_public_path__ + "media/assets/images/logo_white-e03f8935c49c0a6ac078e50fc41ccf77.png";